import React, { useState } from 'react';
import { Spin, Modal } from 'antd';
import CommunityEventForm from './CommunityEventForm';
import { createCommunityEvent } from '../../../services/communityService';

const AddCommunityEvent = ({ isOpen, onCancelModal, communityList }) => {
  const initialValues = {
    title: '',
    description: '',
    liveLink: '',
    recordingLink: '',
    startTime: '',
    endTime: '',
    isActive: false,
    status: 'Active',
    type: 'live',
    communities: [],
    hostFirstName: '',
    hostLastName: '',
    hostProfileImage: '',
    mobileImgSrc: '',
    desktopImgSrc: '',
    trainer: '',
    resources: []
  };

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode'
  });
  const [hostIsTrainer, setHostIsTrainer] = useState(false);
  const [trainer, setTrainer] = useState(null);

  const validateDate = (startDate, endDate) => {
    return new Date(startDate).getTime() < new Date(endDate).getTime();
  };

  const onSubmit = async (values) => {
    const submitValues = {
      title: values.title,
      description: values.description,
      liveLink: values.liveLink,
      recordingLink: values.recordingLink,
      startTime: values.startTime,
      endTime: values.endTime,
      isActive: values.isActive,
      status: values.status,
      type: values.type,
      communities: values.communities,
      host: {
        firstName: trainer?.firstName ?? values.hostFirstName,
        lastName: trainer?.lastName ?? values.hostLastName,
        profileImage: trainer?.profileImage ?? values.hostProfileImage
      },
      cardImgData: {
        alt: values.title,
        mobileImgData: {
          src: values.mobileImgSrc,
          meta: {
            width: 280,
            height: 220
          }
        },
        desktopImgData: {
          src: values.desktopImgSrc,
          meta: {
            width: 280,
            height: 220
          }
        }
      },
      resources: values.resources
    };
    if (!validateDate(values.startTime, values.endTime)) {
      setStatus({
        type: 'ERROR',
        message: 'Start time cannot be after end time!'
      });
    }
    await createCommunityEvent({
      ...submitValues,
      isActive: submitValues.isActive === 'True'
    })
      .then((response) => {
        console.log('Successfully Added! ', response);
        setStatus({
          type: 'SUCCESS',
          message: 'Data added successfully!'
        });
      })
      .catch((error) => {
        alert('Posting data to backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };
  return (
    <Modal
      title={`Add Community Event`}
      visible={isOpen}
      onCancel={() => onCancelModal()}
      footer={null}>
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <CommunityEventForm
          initialValues={initialValues}
          setStatus={setStatus}
          status={status}
          type="Add"
          onSubmit={onSubmit}
          hostIsTrainer={hostIsTrainer}
          setHostIsTrainer={setHostIsTrainer}
          setTrainer={setTrainer}
          communityList={communityList}
        />
      )}
    </Modal>
  );
};

export default AddCommunityEvent;
